<div class="survey-container">
    <div class="survey-card">
        <div class="survey-header">
            <h2>{{ config.title | translate }}</h2>
            <div class="progress-indicator">
                <span class="step-text">{{ currentSection.title | translate }}</span>
                <span class="step-count">{{ currentStep + 1 }}/{{ totalSteps }}</span>
            </div>
            <div class="progress-bar-bg">
                <div class="progress-bar-fill" [style.width.%]="((currentStep + 1) / totalSteps) * 100"></div>
            </div>
        </div>

        <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">

            <div class="section-content">
                @for (question of currentSection.questions; track question.key) {
                @if (isQuestionVisible(question)) {
                <div class="form-group survey-field">
                    <label [class.required]="question.required">
                        {{ question.label | translate }}
                    </label>

                    @switch (question.type) {
                    @case ('select') {
                    <div class="custom-select-wrapper">
                        <input type="text" class="survey-input"
                            [placeholder]="(question.placeholder | translate) || ('SURVEY.SELECT_OPTION' | translate)"
                            [value]="getDisplayValue(question)" (input)="onSearch(question.key, $event)"
                            (focus)="toggleDropdown(question.key, true)" (click)="toggleDropdown(question.key, true)" />

                        @if (hasSelection(question)) {
                        <div class="custom-dropdown-clear" (click)="clearSelection(question, $event)"></div>
                        } @else {
                        <div class="custom-dropdown-arrow" (click)="toggleDropdown(question.key)"></div>
                        }

                        @if (dropdownOpenRegex[question.key]) {
                        <div class="custom-options-list">
                            @for (opt of getFilteredOptions(question); track opt.value) {
                            <div class="custom-option" (click)="selectOption(question, opt)"
                                [class.selected]="surveyForm.get(question.key)?.value === opt.value">
                                {{ opt.label | translate }}
                            </div>
                            }
                            @if (getFilteredOptions(question).length === 0) {
                            <div class="custom-option no-results">{{'SURVEY.NO_RESULTS' | translate}}</div>
                            }
                        </div>
                        }

                        <!-- Transparent backdrop to close on click outside -->
                        @if (dropdownOpenRegex[question.key]) {
                        <div class="dropdown-backdrop" (click)="toggleDropdown(question.key, false)"></div>
                        }
                    </div>
                    }

                    @case ('multi-select') {
                    <div class="checkbox-grid">
                        @for (opt of question.options; track opt.value) {
                        <label class="checkbox-card"
                            [class.checked]="surveyForm.get(question.key)?.value.includes(opt.value)">
                            <input type="checkbox" [value]="opt.value"
                                (change)="onCheckboxChange(question.key, opt.value, $event)"
                                [checked]="surveyForm.get(question.key)?.value.includes(opt.value)">
                            <span class="checkmark"></span>
                            <span class="checkbox-label">{{ opt.label | translate }}</span>
                        </label>
                        }
                    </div>
                    }

                    @case ('radio') {
                    <div class="survey-radio-group">
                        @for (opt of question.options; track opt.value) {
                        <label class="survey-radio-label">
                            <input type="radio" [formControlName]="question.key" [value]="opt.value"
                                class="survey-radio" />
                            <span>{{opt.label | translate}}</span>
                        </label>
                        }
                    </div>
                    }

                    @case ('rating') {
                    <div class="rating-container">
                        <div class="rating-labels">
                            <span>{{'SURVEY.BAD' | translate}}</span>
                            <span>{{'SURVEY.EXCELLENT' | translate}}</span>
                        </div>
                        <div class="rating-scale">
                            @for (val of [0, 1, 2, 3, 4, 5]; track val) {
                            <div class="rating-item" [class.selected]="surveyForm.get(question.key)?.value === val"
                                (click)="setRating(question.key, val)">
                                {{ val }}
                            </div>
                            }
                        </div>
                    </div>
                    }

                    @case ('textarea') {
                    <textarea [formControlName]="question.key" class="survey-input survey-textarea"
                        [placeholder]="question.placeholder ? (question.placeholder | translate) : ''" rows="4"></textarea>
                    }

                    @case ('text') {
                    <input type="text" [formControlName]="question.key" class="survey-input"
                        [placeholder]="question.placeholder ? (question.placeholder | translate) : ''">
                    }

                    @case ('number') {
                    <input type="number" [formControlName]="question.key" class="survey-input"
                        [placeholder]="question.placeholder ? (question.placeholder | translate) : ''" min="0">
                    }
                    }

                    @if (surveyForm.get(question.key)?.invalid && surveyForm.get(question.key)?.touched) {
                    <div class="error">{{'SURVEY.REQUIRED_FIELD' | translate}}</div>
                    }
                </div>
                }
                }
            </div>

            <div class="form-actions">
                @if (currentStep > 0) {
                <button type="button" class="survey-btn secondary-btn" (click)="prevStep()">{{'SURVEY.PREVIOUS' | translate}}</button>
                }

                @if (currentStep < totalSteps - 1) { <button type="button" class="survey-btn" (click)="nextStep()">
                    {{'SURVEY.NEXT' | translate}}</button>
                    } @else {
                    <button type="submit" class="survey-btn" [disabled]="isSubmitting">
                        @if (isSubmitting) {
                        <div class="spinner"></div>
                        } @else {
                        <span>{{'SURVEY.SUBMIT' | translate}}</span>
                        }
                    </button>
                    }
            </div>
        </form>
    </div>
</div>